/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportConfigurationForAssessmentRunViolation extends models.ReportConfigurationForAssessmentRun {
    constructor() {
        super();
        this.setDiscriminator("ReportConfigurationForAssessmentRunViolation");
    }

    getFixupPrototypeFunction() { return ReportConfigurationForAssessmentRunViolation.fixupPrototype; }

    static newInstance(model: Partial<ReportConfigurationForAssessmentRunViolation>): ReportConfigurationForAssessmentRunViolation {
        let obj = Object.assign(new ReportConfigurationForAssessmentRunViolation(), model);
        ReportConfigurationForAssessmentRunViolation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportConfigurationForAssessmentRunViolation>): ReportConfigurationForAssessmentRunViolation {
        if (!model) return null;
        return ReportConfigurationForAssessmentRunViolation.newInstance(<ReportConfigurationForAssessmentRunViolation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportConfigurationForAssessmentRunViolation) {
        if (!obj) return;

        models.ReportConfigurationForAssessmentRunViolation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportConfigurationForAssessmentRunViolation): boolean {
        if (models.ReportConfigurationForAssessmentRun.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportConfigurationForAssessmentRunViolation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
